import React from "react";
import { maturityProfile } from "../../data/findings";
const pct = (score: number) => `${score / 5 * 100}%`;
export function MaturityProfile() {
  const overall = maturityProfile.reduce((sum, d) => sum + d.score, 0) / maturityProfile.length;
  return <div className="border border-navy bg-ivory" data-id="element-104" data-mp="399kupawt4idy">
      <div className="flex items-baseline justify-between gap-4 border-b border-navy px-6 py-4" data-id="element-105" data-mp="34fqi0rfmd3od">
        <p className="eyebrow text-navy" data-id="element-106" data-mp="3i7510y9j14vf">Payroll maturity</p>
        <p className="text-[11px] tabular-nums text-charcoal/60" data-id="element-107" data-mp="3e6l5fz4lq9be">Client profile · 2026</p>
      </div>

      <div className="flex items-end justify-between gap-6 border-b border-stone px-6 py-6" data-id="element-108" data-mp="3s6cbndovmleu">
        <div data-id="element-109" data-mp="3n79jgttzw9oa">
          <p className="text-sm text-charcoal/70" data-id="element-110" data-mp="3n7j0vt0z58id">Overall</p>
          <p className="eyebrow mt-2 text-oxblood" data-id="element-111" data-mp="3n82krfa6q6z1">Stage IV · Controlled</p>
        </div>
        <p className="font-display text-6xl leading-none tabular-nums text-navy" data-id="element-112" data-mp="1xsuvwcupqsud">{overall.toFixed(1)}</p>
      </div>

      <ul className="px-6 py-3" data-id="element-113" data-mp="1svcpou82yrq2">
        {maturityProfile.map(d => <li key={d.name} className="flex items-center gap-4 py-3" data-id="element-114" data-mp="18w4bt8y7stk1">
            <span className="w-28 shrink-0 text-sm text-charcoal" data-id="element-115" data-mp="1dsur3u273l4e">{d.name}</span>
            <span className="relative block h-1.5 flex-1 bg-stone" aria-hidden data-id="element-116" data-mp="1hvhla1mc9i4r">
              <span className="absolute inset-y-0 left-0 bg-navy" style={{
            width: pct(d.score)
          }} data-id="element-117" data-mp="1htelwqzaqcnd" />
              <span className="absolute -top-1.5 h-[18px] w-0.5 bg-oxblood" style={{
            left: pct(d.peerMedian)
          }} data-id="element-118" data-mp="1mnsp3fk79o2l" />
            </span>
            <span className="w-9 shrink-0 text-right font-display text-xl tabular-nums text-navy" data-id="element-119" data-mp="1wjcgbontjyl0">{d.score.toFixed(1)}</span>
            <span className="sr-only" data-id="element-120" data-mp="21kjnpmm1uvr5">
              {d.name}: {d.score} of 5. Peer median {d.peerMedian}.
            </span>
          </li>)}
      </ul>

      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-stone px-6 py-3 text-[11px] text-charcoal/60" data-id="element-121" data-mp="75h5m9zbyfy9">
        <span className="flex items-center gap-2" data-id="element-122" data-mp="b7ua6v2cc7tg">
          <span aria-hidden className="block h-1.5 w-5 bg-navy" data-id="element-123" data-mp="1ehouynequ99t" />
          Client
        </span>
        <span className="flex items-center gap-2" data-id="element-124" data-mp="19ilnkwbajqyo">
          <span aria-hidden className="block h-3 w-0.5 bg-oxblood" data-id="element-125" data-mp="19jx29r69yj4k" />
          Peer median
        </span>
        <span data-id="element-126" data-mp="1nj6ao4o8o8xz">Scored 1–5. Illustrative.</span>
      </div>
    </div>;
}